var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"carbon-btn",attrs:{"dark":"","x-large":"","icon":Boolean(_vm.icon)},on:{"click":_vm.click}},'v-btn',{ color: 'rgba(84, 139, 62, 0.9)', ..._vm.vueBind },false),[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }